export enum TimeFormat {
  DEFAULT = 'default',
  CONCISE = 'concise',
  NUMERIC = 'numeric'
}

export interface CountdownState {
  timeout: any | null
  tickInProgress: boolean
  countdownComplete: boolean
  hasPassed: boolean | undefined
}

export interface CountdownProps {
  date: string
  onChange?(data: { live: boolean }): void
  color?: string
  overrunColor?: string
  allowMinus?: boolean
  countdownText?: string
  className?: string
  countdownTextClassName?: string
  countdownClassName?: string
  dataBdd?: string
  format?: TimeFormat
  countDownFormat?: string
}
